import { defineTheme } from '../contracts.js';
export const tfiFriday = defineTheme({
    id: 'tfi-friday',
    displayName: 'TFI Friday',
    lifecycle: 'ready',
    selectable: true,
    implementation: 'legacy',
    extensionThemeId: 'friday',
    capabilities: {
        alerts: 'available',
        welcomes: 'available',
        wam: 'external',
        startup: 'external',
        achievements: 'unsupported',
        viewerSounds: 'external',
        privateChatSounds: 'unsupported',
    },
});
//# sourceMappingURL=registration.js.map